<template>
    <div>
        <h1>{{ transl["STR_TITLE_DOCUMENTS"] }}</h1>
        {{  transl["STR_IFU"]}}
        <ul>
            <li><a href="https://shop.procomcure.com/dl/ifu.pdf" target="_blank">
                {{ transl["STR_IFU_FILE1"] }}
            </a></li>
        </ul>
    </div>
</template>
<style scoped>
a {
    text-decoration: none;
    color: black;
}
</style>
<script>
export default({
    props: [ 'transl' ],
    setup() {
        alert("OK")
    },
})
</script>
